/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Mechdoud's Portfolio",
  description:
    "👋 Hello! I'm MECHDOUD Mohammed, a versatile professional with expertise in software development, database administration, data analysis, and graphic design. As a seasoned software developer, I specialize in creating robust solutions that optimize performance and enhance user experiences. My proficiency extends to database administration, where I excel in designing and managing databases to ensure data integrity and accessibility.",
  og: {
    title: "Mechdoud Portfolio",
    type: "website",
    url: "http://mechdoud.com",
  },
};

//Home Page
const greeting = {
  title: "MECHDOUD Mohammed",
  logo_name: "Mohammed",
  nickname: "",
  subTitle:
    "👋 Hello! I'm MECHDOUD Mohammed, a versatile professional with expertise in software development, database administration, data analysis, and graphic design. As a seasoned software developer, I specialize in creating robust solutions that optimize performance and enhance user experiences. My proficiency extends to database administration, where I excel in designing and managing databases to ensure data integrity and accessibility.",
  resumeLink:
    "https://drive.google.com/file/d/1ljpKUHJNX27EG4QV2HUiFINs7qW8TQdE/view?usp=sharing",
  portfolio_repository: "https://github.com/mechdoudmohammed",
  githubProfile: "https://github.com/mechdoudmohammed",
};

const socialMediaLinks = [
  /* Your Social Media Link */

  {
    name: "Github",
    link: "https://github.com/mechdoudmohammed",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/mechdoudmohammed",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },

  {
    name: "Gmail",
    link: "mailto:mechdoud.med@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Skilled in developing deep learning models using Convolutional Neural Networks (CNNs) for imaging and Transformers for NLP applications.",
        "⚡ Proficient in Python with expertise in TensorFlow and PyTorch, delivering end-to-end machine learning and AI solutions.",
        "⚡ Experienced in building and deploying scalable applications and APIs using FastAPI for seamless integration with AI models.",
        "⚡ Strong background in applying advanced statistical analysis and data-driven modelling for problem-solving and insights generation.",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive web applications using Vue.js, JavaScript, Bootstrap",
        "⚡ Developing backend systems with Python (Flask) and PHP (Laravel)",
        "⚡ Designing intuitive and user-friendly UI/UX interfaces",
        "⚡ Basic knowledge of Java for application development",
        "⚡ Currently learning and exploring React and Node.js",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "simple-icons:gatsby",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
      ],
    },
    {
      title: "Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing modern and responsive websites, interfaces, and features",
        "⚡ Creating complete brand identities including logos, brochures, flyers, and social media content",
        "⚡ Skilled in video editing, motion design, and gaming intros/effects",
        "⚡ Developing high-quality presentations and visual storytelling",
        "⚡ End-to-end design solutions for digital and print media",
      ],
      softwareSkills: [
        {
          skillName: "Adobe",
          fontAwesomeClassname: "simple-icons:adobe",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Adobe photoshop",
          fontAwesomeClassname: "simple-icons:adobephotoshop",
          style: {
            color: "#015ed0ff",
          },
        },
        {
          skillName: "Adobe affter effect",
          fontAwesomeClassname: "simple-icons:adobeaftereffects",
          style: {
            color: "#00005b",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/layman_brother/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/Mechdoud_1919",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@Mechdoud391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Chouaib Doukkali University, El Jadida",
      subtitle: "Master’s Degree in Business Intelligence & Big Data Analytics",
      logo_path: "fslogo.webp",
      alt_name: "Chouaib Doukkali University, El Jadida",
      duration: "2023 - 2025 | Graduated with Merit",
      descriptions: [
        "⚡ Studied advanced subjects including Intelligence Artificielle, MongoDB, Mathematics, Databases, Indexation & Search Systems, Big Data (Hadoop), Data Management, Data Warehousing, and Decision Support Systems.",
        "⚡ Gained expertise in Image Processing, Multi-Agent Systems, Python Programming, Deep Learning, and Data Visualization (Power BI).",
        "⚡ Practical experience with Sentiment Analysis, Text Mining, and Applied Research in Medical Imaging using Transformers for Mammography.",
      ],
      website_link: "https://www.ucd.ac.ma",
    },
    {
      title: "Chouaib Doukkali University, El Jadida",
      subtitle: "Professional Bachelor’s Degree – Database Administration (ABD)",
      logo_path: "fslogo.webp",
      alt_name: "Chouaib Doukkali University, El Jadida",
      duration: "2021 – 2022 | Graduated with Merit",
      descriptions: [
        "⚡ Studied relational and NoSQL databases: Oracle, SQL Server, SQL+, Neo4j, MongoDB.",
        "⚡ Gained proficiency in Python programming and web development.",
        "⚡ Practical training in computer networks, software engineering, and UML modeling.",
      ],
      website_link: "https://www.ucd.ac.ma",
    },
    {
      title: "BTS Institute, Fez",
      subtitle: "Higher Technician Diploma (BTS) – Information Systems Development (DSI)",
      logo_path: "btslogo2.webp",
      alt_name: "Chouaib Doukkali University, El Jadida",
      duration: "2019 – 2021 | Graduated with High Honors",
      descriptions: [
        "⚡ Studied mathematics, programming, and object-oriented development (Java, C, Assembler).",
        "⚡ Gained skills in web development (PHP, JavaScript, .NET) and client-server applications.",
        "⚡ Training in databases (MySQL), UML & Merise modeling, and software engineering methodologies.",
        "⚡ Knowledge of project management and software lifecycle practices.",
      ],
      website_link: "https://lycee-technique-fes.ma",
    },
    {
      title: "Higher School of Technology (EST), Fez",
      subtitle: "First-Year Student in Statistics and Decision-Making Computer Science (STID)",
      logo_path: "estfes.webp",
      alt_name: "Higher School of Technology (EST), Fez",
      duration: "2018 – 2019",
      descriptions: [
        "⚡ Gained foundations in economics, mathematics, and statistics.",
        "⚡ Acquired practical skills in Excel, C programming, and Linux.",
      ],

      website_link: "http://www.est-usmba.ac.ma",
    },
    {
      title: "Al Khawarizmi High School, Fez",
      subtitle: "Baccalaureate in Physical Sciences (PC)",
      logo_path: "bac.webp",
      alt_name: "Al Khawarizmi High School, Fez",
      duration: "2017 – 2018 | Graduated with Merit",
      descriptions: [
        "⚡ Gained strong foundations in physics, mathematics, English, and experimental sciences.",
        "⚡ Improved communication skills through French language courses.",
        "⚡ racticed academic presentations and prepared for higher-level studies.",
      ],

      website_link: "",
    },


  ],
};

// Experience Page
const experience = {
  id: "054",
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description: "Full-stack developer and digital solutions specialist with a diverse background in web development, data engineering, graphic design, and technical consulting. I work with startups and established businesses to build scalable applications, optimize data infrastructure, and create compelling digital experiences. Passionate about delivering end-to-end solutions that bridge technical excellence with creative innovation.",
  header_image_path: "experienceimage.webp",
  sections: [
    {
      id: "011",
      title: "Work",
      work: true,
      experiences: [
        {
          id: "05",
          title: "Freelance Developer & Digital Solutions Consultant",
          company: "Self-Employed",
          company_url: "", // Your portfolio/website URL if available
          logo_path: "freelancelogo.webp", // Or your personal brand logo
          duration: "Jun 2018 – Present",
          location: "Remote",
          description: [
            " Provide comprehensive web development solutions using modern frameworks and technologies for diverse clients.",
            " Deliver end-to-end services including graphic design, data engineering, and database administration.",
            " Design and implement scalable database architectures and optimize data workflows for business intelligence.",
            " Offer digital marketing strategies and technical consultation to help businesses enhance their online presence.",
            " Manage multiple projects across various domains while ensuring quality delivery and client satisfaction."
          ],
          color: "#6366f1", // Professional indigo color
        },
        {
          id: "01",
          title: "Python Developer & Data Analyst – Internal Project",
          company: "ColiColi",
          company_url: "https://www.colicoli.fr",
          logo_path: "colicoli/colicolilogo.webp",
          duration: "Jun 2024 – Oct 2025",
          location: "Remote, France",
          description:
            [
              " Developed Python applications for data processing and automation tasks.",
              " Built data analysis workflows to extract insights and support business decision-making.",
              " Designed data visualization dashboards and reports to track performance.",
              " Contributed to the integration of data science and analytics solutions into company operations."
            ],
          color: "#000000",
        },
        {
          id: "02",
          title: "Graphic Designer – Marketing Team Member",
          company: "Colicoli",
          company_url: "https://www.colicoli.fr",
          logo_path: "colicoli/colicolilogo.webp",
          duration: "Dec 2023 – Jun 2024",
          location: "Remote, France",
          description: [
            " Designed engaging visual content including social media posts, promotional videos, and marketing materials.",
            " Produced motion graphics, video editing, and presentation designs to support campaigns.",
            " Collaborated with the marketing team to strengthen brand identity and digital presence."],
          color: "#0879bf",
        },
        {
          id: "03",
          title: "Co-Founder & Full-Stack Developer",
          company: "Colizone",
          company_url: "",
          logo_path: "colizonlogo.webp",
          duration: "Apr 2023 – Dec 2023",
          location: "Morocco",
          description: [
            " Co-founded and developed a comprehensive delivery management system using Laravel and Vue.js framework.",
            " Led the technical development and implementation of the delivery agency's digital infrastructure.",
            " Designed and built a complete logistics management platform handling order processing, delivery tracking, and agency operations.",
            " Managed end-to-end software development lifecycle from system architecture to deployment and maintenance."
          ],
          color: "#0879bf",
        },
        {
          id: "04",
          title: "Freelance Graphic Designer",
          company: "Khamsat",
          company_url: "https://khamsat.com",
          logo_path: "khamsatlogo.webp",
          duration: "2018 – 2022",
          location: "Remote",
          description: [
            " Delivered graphic design services to diverse clients across the MENA region through Khamsat platform.",
            " Created visual content including logos, social media graphics, branding materials, and digital illustrations.",
            " Managed multiple client projects simultaneously while maintaining high quality standards and meeting deadlines.",
            " Built a strong portfolio and positive client reviews through consistent delivery of professional design solutions."
          ],
          color: "#00a651", // Khamsat's green color
        }
      ],
    },
    {
      id: "03",
      title: "Internships",
      experiences: [
        {
          id: "033",
          title: "Final Year Internship – Vehicle Rental Agency Management",
          company: "GeoTech Info",
          company_url: "",
          logo_path: "geotechinfo.webp",
          duration: "Jul 2022 – Oct 2022",
          location: "Fes, Morocco",
          description:
            [
              " Developed a web application for managing vehicle rental operations.",
              " Built using Laravel framework with Vue.js for an interactive and responsive interface.",
              " Implemented features for vehicle management, booking tracking, customer records, and payment handling.",
              " Optimized backend logic to improve reservation processing and real-time vehicle availability updates."],
          color: "#000000",
        },
        {
          id: "04",
          title: "Final Year Internship – Internal Management of Parapharmacies",
          company: "OCTOBOT Consulting & Training",
          company_url: "",
          logo_path: "octobotlogo.webp",
          duration: "May 2021 – Jun 2021 ",
          location: "Fes, Morocco",
          description:
            [
              " Developed a web application for managing internal operations of parapharmacies.",
              " Built using Laravel framework with Bootstrap for responsive design.",
              " Implemented features for inventory tracking, sales management, and workflow optimization."],
          color: "#ee3c26",
        },
        {
          id: "05",
          title: "Final Year Project – Medical Equipment Rental & Sales Management",
          company: "Home",
          company_url: "",
          logo_path: "btslogo.webp",
          duration: "Feb 2021 – Jun 2021 | Fes, Morocco",
          location: "Work From Home",
          description: [
            " Developed a complete web application(Laravel framework) and mobile application(Flutter) for managing a medical equipment company.",
            " Designed and implemented an e- commerce platform for rental and sales operations.",
            " Built features to handle inventory management, client interactions, and transaction workflows."],
          color: "#0071C5",
        },
      ],
    },

  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "btslogo.webp",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "",
    },
    {
      id: "mdp-diffusion",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "",
    },
  ],
};

// Contact Page
// Contact Page Data for portfolio.js
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "me.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android, Cloud and Opensource Development.",
  },

  addressSection: {
    title: "Contact Information",
    subtitle: "Let's connect and bring your project to life",
    locality: "Fes",
    country: "Morocco",
    region: "Fès-Meknès",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "me.webp",
    location_map_link: "https://goo.gl/maps/your-location",
    email: "mechdoud.med@gmail.com",
    phone: "+212 66 00 83 005"
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+212 66 00 83 005",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
